var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg/icons.svg#wemply';
                    var viewUrl = 'svg/icons.svg#view-wemply';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 50 50',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };